import React from 'react'
import GuestAppliedMultipleLogin from './GuestAppliedMultipleLogin'

export default function IndexMultiple(props) {
  
  return (
    <GuestAppliedMultipleLogin {...props}/>
  )
}
